<template>
  <div>
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between align-center" style="width:100%">
          <h3>Platform Status</h3>
          <v-btn text color="rgb(0,170,221)" @click="getData">Refresh</v-btn>
        </div>
      </v-card-title>

      <v-card-text>
        <v-data-table
          disable-sort
          hide-default-footer
          :headers="headers"
          :items="data"
          :loading="loading"
        ></v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  created() {
    this.getData();
  },

  data() {
    return {
      loading: false,
      headers: [
        {
          text: "Unverified doctors",
          value: "notVerifiedDoctorsNum"
        },
        {
          text: "Approved doctors",
          value: "aprovedDoctorsNum"
        },
        {
          text: "Pending approval doctors",
          value: "pendingApprovalDoctorsNum"
        },
        {
          text: "Verified patients",
          value: "verifiedTravellersNum"
        },
        {
          text: "Unverified patients",
          value: "notVerifiedTravellersNum"
        }
      ],
      data: []
    };
  },

  methods: {
    getData() {
      this.data.pop();
      axios
        .get(`${process.env.VUE_APP_BASE_URL}admin/platformStatus`)
        .then(res => {
          console.log(res);
          this.data.push(res.data);
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    }
  }
};
</script>